import { compose } from "redux";

import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import SfJobWizardContainer from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/containers/SfJobWizardContainer";
import { withConnectionCheck } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withConnectionCheck";
import withCrmEnrichmentProvider from "app/pages/sales-intelligence/pages/manage-integration/hocs/withCrmEnrichmentProvider";
import withIntegrationAccess from "app/pages/sales-intelligence/pages/manage-integration/hocs/withIntegrationAccess";
import { withMappingsAndColumnsFetch } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withMappingsAndColumnsFetch";

const SfEnrichmentJobWizardContainer = compose(
    withCrmEnrichmentProvider,
    withConnectionCheck,
    withIntegrationAccess,
    withSecondaryBarSet("SalesIntelligenceManagement"),
    withMappingsAndColumnsFetch({ refetchIfExists: true }),
)(SfJobWizardContainer);

export default SfEnrichmentJobWizardContainer;
